import React from 'react';
import { isMobile } from '@pascal/pascal-core';
import { PlayerCardsBox } from '../playerCardsBox';
import { BankerCardsBox } from '../bankerCardsBox';
import { Timer } from '../timer';

export function RoundCards() {
  return (
    <div className='table-cards-cont place-bets'>
      {/* 'place-bets' */}
      <div className='table-cards-inner-cont'>
        <PlayerCardsBox />
        {isMobile() ? <Timer /> : null}
        <BankerCardsBox />
      </div>
    </div>
  );
}
